export default {
    namespaced: true,

    state: {
        currency_balance_owing_in_cents: 0,
        transaction_date: '',
    },

    mutations: {
        setData(state, data) {
            state.currency_balance_owing_in_cents = data.currency_balance_owing_in_cents;
            state.transaction_date = data.transaction_date;
        },

        reset(state) {
            state.currency_balance_owing_in_cents = 0;
            state.transaction_date = '';
        },
    },
};
